import styled from "styled-components";
import ornament from "../../assets/images/ornament.png"; // <- adaugă asta
import ornament3 from "../../assets/images/ornament3.png"; // <- adaugă asta

export const PageWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0 20px 0;
`;

export const Hero = styled.section`
  position: relative;
  min-height: 46vh;
  display: grid;
  place-items: center;
  background: linear-gradient(180deg, #0c0c0c 0%, #111 100%);
  color: #fff;
`;

export const HeroInner = styled.div`
  text-align: center;
  padding: 32px 16px;
  max-width: 960px;
`;

export const HeroTitle = styled.h1`
  margin: 0 0 8px;
  font-size: clamp(28px, 4vw, 56px);
  line-height: 1.05;
  letter-spacing: 0.3px;
`;

export const HeroSubtitle = styled.p`
  margin: 0;
  opacity: 0.9;
  font-size: clamp(14px, 1.6vw, 18px);
`;

export const Section = styled.section`
  padding: 0px 7px 0px;
  background: transparent;
  color: #111;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 18px;
  font-size: clamp(22px, 2.4vw, 32px);
`;

export const Grid = styled.div`
  display: grid;
  place-items: center;
  gap: 20px;
`;

export const Ornament = styled.div`
  height: 39px;
  background: url(${ornament3}) no-repeat center;
  background-size: contain;

  @media (max-width: 940px) {
    background: url(${ornament}) no-repeat center;
    height: 42px;
    background-size: contain;
  }
`;
